export const LINK_DISPLAY_VALUE = 'inline';
